// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!../../../node_modules/postcss-loader/dist/cjs.js!../library/style/colors.css";
import ___CSS_LOADER_ICSS_IMPORT_1___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!../../../node_modules/postcss-loader/dist/cjs.js!../library/style/breakpoint.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_1___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Mq4SEUtRd7araJZUrNQP {
    width: 100%;
    background-color: #FFFFFF;
    box-shadow: 0 0 16px 8px rgba(39, 48, 101, 0.04);
}

.tKygQ4LMDikHs5Hsh0Qk {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    gap: 1rem;

    position: sticky;
    top: 0;
    padding-right: 2rem;
    padding-left: 2rem;
}

.rOqxapQkQcUqxPH1IIIi {
    width: 100%;
    display: flex;
    flex-direction: row;
    gap: 1rem;
}

.LOisMOHJ3aQEF092bxcQ {
    display: flex;
    flex-direction: row;
    list-style: none;
    gap: 1rem;
    padding-left: 0;
    margin: 0;
}

.kXloclNtBoogwkcWvUJQ, .VT7vrIbFRCSjs6mrLoSQ:hover {
    color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-purple"]} !important;
    background-color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-purple-bg"]};
    outline: none;

    display: flex;
    justify-content: space-between;
}

.VT7vrIbFRCSjs6mrLoSQ, .cWb6Az3wax7G6DzhJ4y9 {
    width: 100%;
    display: flex;
    line-height: 20px;
    padding: 0.5rem 1rem;
    align-items: center;
    box-sizing: border-box;
    border-radius: 5px;

    text-decoration: none;
    font-family: Roboto, sans-serif;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    color: #000000;

    transition: .3s;

    background: none;
    border: none;
    cursor: pointer;
}

.fUnS8BXXQeLUzup7jb9J {
    font-family: Fjalla One, sans-serif;
    font-style: normal;
    font-weight: normal;
    font-size: 24px;
    color: #000000;
    margin: 0;
    display: flex;
    align-items: center;
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
}

.fUnS8BXXQeLUzup7jb9J span {
    font-family: Fjalla One, sans-serif;
    font-style: normal;
    font-weight: normal;
    font-size: 24px;
    color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-purple"]};
}

.khmPeHvfGzncrWIOWgqc {
    padding-left: 24px;
    margin-top: 0;
    font-family: Raleway, sans-serif;
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
}

.JEy1mpMxOmIACcQpl6Td {
    margin-right: 8px;
    color: #C4C4C4;
    transition: .3s
}

.kXloclNtBoogwkcWvUJQ .JEy1mpMxOmIACcQpl6Td, .VT7vrIbFRCSjs6mrLoSQ:hover .JEy1mpMxOmIACcQpl6Td {
    color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-purple"]};
}

li .kXloclNtBoogwkcWvUJQ,
.SQ8jQd3l5PnFosf_VQDr li .kXloclNtBoogwkcWvUJQ {
  background-color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-purple-bg"]};
}
.AGQ09zuCB6UeJHPy1Ayn {
    display: flex;
    flex-direction: row;
    align-items: center;
    font-weight: 400;
    font-size: 16px;
}

.TGbxoEbvOYmN7MCYpZYP {
    opacity: 0;
}

.kXloclNtBoogwkcWvUJQ .TGbxoEbvOYmN7MCYpZYP {
    opacity: 1;
}

.cWb6Az3wax7G6DzhJ4y9:hover, .cWb6Az3wax7G6DzhJ4y9:hover .JEy1mpMxOmIACcQpl6Td {
    color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-purple"]};
}

.hEeXA6g9BM0HOy6NPhmS {
    position: fixed;
    top: 8px;
    left: 8px;
    width: 48px;
    height: 48px;
    z-index: 100;

    display: none;
    align-items: center;
    justify-content: center;

    border-radius: 5px;

    background-color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-purple"]};
    color: white;
}

.Yb7SCpyxv46apJytZvNE {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
}

.smVvdDteygB5Wk2wINLT {
    display: none;
    align-items: center;
    justify-content: center;
    margin-right: 24px;

    border-radius: 5px;

    width: 48px;
    height: 48px;

    background-color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-purple"]};
    color: white;
}

.ZI9asQOWFgriH6p1ikq2 {
    width: 90%;
    margin: auto auto 16px;
    padding: 8px;
    border-radius: 5px;
    background-color: #F4F5F7;
}

.lNi_1McCXhbWabqgJY_w {
    text-align: center;
    font-weight: 500;
    font-size: 18px;
    margin: 8px 0 0 0;
}

.hC_Yp5meRqs2c9uzKKLV {
    text-align: center;
    font-weight: 500;
    margin-bottom: 0;
}

.CASlOGfstXW2SaazcefP {
    text-align: center;
    color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-text-subtle"]};
    margin: 0 0 16px 0;
}

.t7I0xMVRetekp7GeAEQT {
    background-color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-purple"]};
    color: white;

    width: 32px;
    height: 32px;
    border-radius: 32px;
    margin-right: 8px;

    display: flex;
    justify-content: center;
    align-items: center;
}

.maSQzZ5wQZ8auHaXVS3p {
    display: flex;
    flex-direction: row;
    margin: 8px 0;
}

.maSQzZ5wQZ8auHaXVS3p span {
    align-self: center;
}

.zx30ypfJQoADLZJfiykx {
    font-size: 16px;
    margin-top: 24px;
    width: 100%;
}

.ZI9asQOWFgriH6p1ikq2 .JEy1mpMxOmIACcQpl6Td {
    color: white;
    margin: 0;
    font-size: 18px;
}

.f6iOWGL4DsNOsL0yKl06 {
    color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-text-subtle"]};
    pointer-events: none;
}

.f6iOWGL4DsNOsL0yKl06:hover {
    background: none;
    color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-text-subtle"]} !important;
}

.f6iOWGL4DsNOsL0yKl06:hover .JEy1mpMxOmIACcQpl6Td {
    color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-gray"]};
}

.GfuQFEIzmJkyIVmfl7Jb {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.puMfxKl9Kz88cMm8tpBc {
    display: none;
}

.SQ8jQd3l5PnFosf_VQDr {
    background-color: white;
    padding: 1rem 2rem;
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
}
.SQ8jQd3l5PnFosf_VQDr li {
    list-style: none;
    padding: 0;
}

@media screen and (max-width: 1024px) {
    .D85HzRU5lU0wn8xmkiVg {
        position: fixed;
        top: 0;
        left: 0;
        z-index: 50;
        width: 100%;
        height: 100vh;
        background-color: #0000009e;
    }
    .hEeXA6g9BM0HOy6NPhmS {
        display: flex;
    }
}

@media screen and (max-width: 768px) {
    .GfuQFEIzmJkyIVmfl7Jb {
        display: none;
    }

    .puMfxKl9Kz88cMm8tpBc {
        display: flex;
    }
}

@keyframes ztFbg4JmutMFx_xXW8OQ {
    0%{
        opacity: 0;
        transform: translateX(-600px);
    }
    50%{
        opacity: 0.5;
        transform: translateX(-300px);
    }
    100%{
        opacity: 1;
        transform: translateX(0);
    }
}

@keyframes fJMWJGOQxz0RCPlXmDMw {
    0%{
        opacity: 1;
        transform: translateX(0);
    }
    50%{
        opacity: 0.5;
        transform: translateX(-300px);
    }
    100%{
        opacity: 0;
        transform: translateX(-600px);
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/Navigation/Navigation.module.css"],"names":[],"mappings":"AAMA;IACI,WAAW;IACX,yBAAyB;IACzB,gDAAgD;AACpD;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;IACnB,SAAS;;IAET,gBAAgB;IAChB,MAAM;IACN,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,SAAS;IACT,eAAe;IACf,SAAS;AACb;;AAEA;IACI,8DAA8B;IAC9B,8DAAiC;IACjC,aAAa;;IAEb,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,WAAW;IACX,aAAa;IACb,iBAAiB;IACjB,oBAAoB;IACpB,mBAAmB;IACnB,sBAAsB;IACtB,kBAAkB;;IAElB,qBAAqB;IACrB,+BAA+B;IAC/B,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,cAAc;;IAEd,eAAe;;IAEf,gBAAgB;IAChB,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,mCAAmC;IACnC,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,cAAc;IACd,SAAS;IACT,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI,mCAAmC;IACnC,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,mDAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,gCAAgC;IAChC,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd;AACJ;;AAEA;IACI,mDAAmB;AACvB;;AAEA;;EAEE,8DAAiC;AACnC;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,mDAAmB;AACvB;;AAEA;IACI,eAAe;IACf,QAAQ;IACR,SAAS;IACT,WAAW;IACX,YAAY;IACZ,YAAY;;IAEZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;;IAEvB,kBAAkB;;IAElB,8DAA8B;IAC9B,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;;IAElB,kBAAkB;;IAElB,WAAW;IACX,YAAY;;IAEZ,8DAA8B;IAC9B,YAAY;AAChB;;AAEA;IACI,UAAU;IACV,sBAAsB;IACtB,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,mDAAwB;IACxB,kBAAkB;AACtB;;AAEA;IACI,8DAA8B;IAC9B,YAAY;;IAEZ,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,iBAAiB;;IAEjB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,mDAAwB;IACxB,oBAAoB;AACxB;;AAEA;IACI,gBAAgB;IAChB,8DAAmC;AACvC;;AAEA;IACI,mDAAiB;AACrB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,uBAAuB;IACvB,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,WAAW;AACf;AACA;IACI,gBAAgB;IAChB,UAAU;AACd;;AAEA;IACI;QACI,eAAe;QACf,MAAM;QACN,OAAO;QACP,WAAW;QACX,WAAW;QACX,aAAa;QACb,2BAA2B;IAC/B;IACA;QACI,aAAa;IACjB;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;IACjB;AACJ;;AAEA;IACI;QACI,UAAU;QACV,6BAA6B;IACjC;IACA;QACI,YAAY;QACZ,6BAA6B;IACjC;IACA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;;AAEA;IACI;QACI,UAAU;QACV,wBAAwB;IAC5B;IACA;QACI,YAAY;QACZ,6BAA6B;IACjC;IACA;QACI,UAAU;QACV,6BAA6B;IACjC;AACJ","sourcesContent":["@value colors: \"../library/style/colors.css\";\n@value color-purple, color-purple-bg, color-gray-light, color-gray, color-text-subtle from colors;\n\n@value breakpoints: \"../library/style/breakpoint.css\";\n@value mobile, tablet, tablet-l, laptop, desktop from breakpoints;\n\n.container {\n    width: 100%;\n    background-color: #FFFFFF;\n    box-shadow: 0 0 16px 8px rgba(39, 48, 101, 0.04);\n}\n\n.navigation {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n    gap: 1rem;\n\n    position: sticky;\n    top: 0;\n    padding-right: 2rem;\n    padding-left: 2rem;\n}\n\n.group {\n    width: 100%;\n    display: flex;\n    flex-direction: row;\n    gap: 1rem;\n}\n\n.list {\n    display: flex;\n    flex-direction: row;\n    list-style: none;\n    gap: 1rem;\n    padding-left: 0;\n    margin: 0;\n}\n\n.selected, .link:hover {\n    color: color-purple !important;\n    background-color: color-purple-bg;\n    outline: none;\n\n    display: flex;\n    justify-content: space-between;\n}\n\n.link, .logOut {\n    width: 100%;\n    display: flex;\n    line-height: 20px;\n    padding: 0.5rem 1rem;\n    align-items: center;\n    box-sizing: border-box;\n    border-radius: 5px;\n\n    text-decoration: none;\n    font-family: Roboto, sans-serif;\n    font-style: normal;\n    font-weight: normal;\n    font-size: 16px;\n    color: #000000;\n\n    transition: .3s;\n\n    background: none;\n    border: none;\n    cursor: pointer;\n}\n\n.logo {\n    font-family: Fjalla One, sans-serif;\n    font-style: normal;\n    font-weight: normal;\n    font-size: 24px;\n    color: #000000;\n    margin: 0;\n    display: flex;\n    align-items: center;\n    padding-top: 0.5rem;\n    padding-bottom: 0.5rem;\n}\n\n.logo span {\n    font-family: Fjalla One, sans-serif;\n    font-style: normal;\n    font-weight: normal;\n    font-size: 24px;\n    color: color-purple;\n}\n\n.caption {\n    padding-left: 24px;\n    margin-top: 0;\n    font-family: Raleway, sans-serif;\n    font-style: normal;\n    font-weight: 500;\n    font-size: 14px;\n}\n\n.icon {\n    margin-right: 8px;\n    color: #C4C4C4;\n    transition: .3s\n}\n\n.selected .icon, .link:hover .icon {\n    color: color-purple;\n}\n\nli .selected,\n.menu li .selected {\n  background-color: color-purple-bg;\n}\n.linkContent {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    font-weight: 400;\n    font-size: 16px;\n}\n\n.arrowIcon {\n    opacity: 0;\n}\n\n.selected .arrowIcon {\n    opacity: 1;\n}\n\n.logOut:hover, .logOut:hover .icon {\n    color: color-purple;\n}\n\n.menuButton {\n    position: fixed;\n    top: 8px;\n    left: 8px;\n    width: 48px;\n    height: 48px;\n    z-index: 100;\n\n    display: none;\n    align-items: center;\n    justify-content: center;\n\n    border-radius: 5px;\n\n    background-color: color-purple;\n    color: white;\n}\n\n.header {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: space-between;\n}\n\n.menuOpenButton {\n    display: none;\n    align-items: center;\n    justify-content: center;\n    margin-right: 24px;\n\n    border-radius: 5px;\n\n    width: 48px;\n    height: 48px;\n\n    background-color: color-purple;\n    color: white;\n}\n\n.contact {\n    width: 90%;\n    margin: auto auto 16px;\n    padding: 8px;\n    border-radius: 5px;\n    background-color: #F4F5F7;\n}\n\n.title {\n    text-align: center;\n    font-weight: 500;\n    font-size: 18px;\n    margin: 8px 0 0 0;\n}\n\n.name {\n    text-align: center;\n    font-weight: 500;\n    margin-bottom: 0;\n}\n\n.job {\n    text-align: center;\n    color: color-text-subtle;\n    margin: 0 0 16px 0;\n}\n\n.iconContainer {\n    background-color: color-purple;\n    color: white;\n\n    width: 32px;\n    height: 32px;\n    border-radius: 32px;\n    margin-right: 8px;\n\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.rowContact {\n    display: flex;\n    flex-direction: row;\n    margin: 8px 0;\n}\n\n.rowContact span {\n    align-self: center;\n}\n\n.button {\n    font-size: 16px;\n    margin-top: 24px;\n    width: 100%;\n}\n\n.contact .icon {\n    color: white;\n    margin: 0;\n    font-size: 18px;\n}\n\n.disabled {\n    color: color-text-subtle;\n    pointer-events: none;\n}\n\n.disabled:hover {\n    background: none;\n    color: color-text-subtle !important;\n}\n\n.disabled:hover .icon {\n    color: color-gray;\n}\n\n.hide-mobile {\n    width: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n}\n\n.hide-desktop {\n    display: none;\n}\n\n.menu {\n    background-color: white;\n    padding: 1rem 2rem;\n    display: flex;\n    flex-direction: column;\n    gap: 0.5rem;\n}\n.menu li {\n    list-style: none;\n    padding: 0;\n}\n\n@media screen and (max-width: 1024px) {\n    .overlay {\n        position: fixed;\n        top: 0;\n        left: 0;\n        z-index: 50;\n        width: 100%;\n        height: 100vh;\n        background-color: #0000009e;\n    }\n    .menuButton {\n        display: flex;\n    }\n}\n\n@media screen and (max-width: 768px) {\n    .hide-mobile {\n        display: none;\n    }\n\n    .hide-desktop {\n        display: flex;\n    }\n}\n\n@keyframes slideInLeft {\n    0%{\n        opacity: 0;\n        transform: translateX(-600px);\n    }\n    50%{\n        opacity: 0.5;\n        transform: translateX(-300px);\n    }\n    100%{\n        opacity: 1;\n        transform: translateX(0);\n    }\n}\n\n@keyframes slideOutLeft {\n    0%{\n        opacity: 1;\n        transform: translateX(0);\n    }\n    50%{\n        opacity: 0.5;\n        transform: translateX(-300px);\n    }\n    100%{\n        opacity: 0;\n        transform: translateX(-600px);\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"colors": `"../library/style/colors.css"`,
	"color-purple": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-purple"]}`,
	"color-purple-bg": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-purple-bg"]}`,
	"color-gray-light": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-gray-light"]}`,
	"color-gray": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-gray"]}`,
	"color-text-subtle": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-text-subtle"]}`,
	"breakpoints": `"../library/style/breakpoint.css"`,
	"mobile": `${___CSS_LOADER_ICSS_IMPORT_1___.locals["mobile"]}`,
	"tablet": `${___CSS_LOADER_ICSS_IMPORT_1___.locals["tablet"]}`,
	"tablet-l": `${___CSS_LOADER_ICSS_IMPORT_1___.locals["tablet-l"]}`,
	"laptop": `${___CSS_LOADER_ICSS_IMPORT_1___.locals["laptop"]}`,
	"desktop": `${___CSS_LOADER_ICSS_IMPORT_1___.locals["desktop"]}`,
	"container": `Mq4SEUtRd7araJZUrNQP`,
	"navigation": `tKygQ4LMDikHs5Hsh0Qk`,
	"group": `rOqxapQkQcUqxPH1IIIi`,
	"list": `LOisMOHJ3aQEF092bxcQ`,
	"selected": `kXloclNtBoogwkcWvUJQ`,
	"link": `VT7vrIbFRCSjs6mrLoSQ`,
	"logOut": `cWb6Az3wax7G6DzhJ4y9`,
	"logo": `fUnS8BXXQeLUzup7jb9J`,
	"caption": `khmPeHvfGzncrWIOWgqc`,
	"icon": `JEy1mpMxOmIACcQpl6Td`,
	"menu": `SQ8jQd3l5PnFosf_VQDr`,
	"linkContent": `AGQ09zuCB6UeJHPy1Ayn`,
	"arrowIcon": `TGbxoEbvOYmN7MCYpZYP`,
	"menuButton": `hEeXA6g9BM0HOy6NPhmS`,
	"header": `Yb7SCpyxv46apJytZvNE`,
	"menuOpenButton": `smVvdDteygB5Wk2wINLT`,
	"contact": `ZI9asQOWFgriH6p1ikq2`,
	"title": `lNi_1McCXhbWabqgJY_w`,
	"name": `hC_Yp5meRqs2c9uzKKLV`,
	"job": `CASlOGfstXW2SaazcefP`,
	"iconContainer": `t7I0xMVRetekp7GeAEQT`,
	"rowContact": `maSQzZ5wQZ8auHaXVS3p`,
	"button": `zx30ypfJQoADLZJfiykx`,
	"disabled": `f6iOWGL4DsNOsL0yKl06`,
	"hide-mobile": `GfuQFEIzmJkyIVmfl7Jb`,
	"hide-desktop": `puMfxKl9Kz88cMm8tpBc`,
	"overlay": `D85HzRU5lU0wn8xmkiVg`,
	"slideInLeft": `ztFbg4JmutMFx_xXW8OQ`,
	"slideOutLeft": `fJMWJGOQxz0RCPlXmDMw`
};
export default ___CSS_LOADER_EXPORT___;
